import * as React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReportForm from "report/report-creation/ReportForm";
import Spinner from "components/common/Spinner";
import useReport from "report/report-history-page/useReport";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import { DocumentTitle } from "components/common";
import ReportRoutes from "report/ReportRoutes";
const EditReportPage = () => {
  const { reportId } = useParams();
  const { data: report, isFetching: isFetchingReport } = useReport(reportId);
  if (isFetchingReport || !report) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    ReportForm,
    {
      action: "edit",
      report,
      ignoredWindowLeaveRoutes: [
        ReportRoutes.EDIT.overview(report.id),
        ReportRoutes.EDIT.content(report.id),
        ReportRoutes.EDIT.delivery(report.id),
        ReportRoutes.EDIT.style(report.id)
      ]
    }
  );
};
const EditReportPageWrapper = () => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("edit_report_page.title") }, /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.report, bsStyle: "danger", displayWarningContainer: true, hideChildren: true }, /* @__PURE__ */ React.createElement(EditReportPage, null)));
};
export default EditReportPageWrapper;
